module.exports = __webpack_public_path__ + "static/media/dcn.f3c07d96.svg";